/*
 * About Us motion: lightweight scroll reveals + digit count-up.
 * - One shared, deferred script (guarded so it initialises only once).
 * - Animates transform/opacity only, and counts up numeric stats.
 * - Respects prefers-reduced-motion and degrades gracefully without JS.
 */
(function () {
  if (window.__ausMotionInit) return;
  window.__ausMotionInit = true;

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var canObserve = 'IntersectionObserver' in window;
  var NUM_RE = /^(\D*)(\d[\d,]*(?:\.\d+)?)(.*)$/;

  function easeOutCubic(t) {
    return 1 - Math.pow(1 - t, 3);
  }

  function runCounter(el) {
    if (el.__ausCounted) return;
    el.__ausCounted = true;

    var raw = el.getAttribute('data-aus-counter') || el.textContent;
    var parts = raw.match(NUM_RE);
    if (!parts) { el.textContent = raw; return; }

    var prefix = parts[1];
    var numeric = parts[2].replace(/,/g, '');
    var suffix = parts[3];
    var decimals = (numeric.split('.')[1] || '').length;
    var end = parseFloat(numeric);
    if (isNaN(end)) { el.textContent = raw; return; }

    var duration = 1400;
    var startTime = null;

    function frame(now) {
      if (startTime === null) startTime = now;
      var progress = Math.min((now - startTime) / duration, 1);
      var value = end * easeOutCubic(progress);
      el.textContent = prefix + value.toFixed(decimals) + suffix;
      if (progress < 1) {
        requestAnimationFrame(frame);
      } else {
        el.textContent = prefix + end.toFixed(decimals) + suffix;
      }
    }
    requestAnimationFrame(frame);
  }

  function reveal(root) {
    root.classList.add('is-visible');
    var counters = root.querySelectorAll('[data-aus-counter]');
    for (var i = 0; i < counters.length; i++) runCounter(counters[i]);
  }

  var observer = canObserve
    ? new IntersectionObserver(function (entries) {
        for (var i = 0; i < entries.length; i++) {
          if (entries[i].isIntersecting) {
            reveal(entries[i].target);
            observer.unobserve(entries[i].target);
          }
        }
      }, { threshold: 0.15, rootMargin: '0px 0px -8% 0px' })
    : null;

  function prep(root) {
    if (root.__ausReady) return;
    root.__ausReady = true;

    if (reduceMotion || !canObserve) {
      reveal(root);
      return;
    }

    root.classList.add('aus-prep');

    // Reset counters to zero so they animate up from nothing.
    var counters = root.querySelectorAll('[data-aus-counter]');
    for (var i = 0; i < counters.length; i++) {
      var c = counters[i];
      var parts = (c.getAttribute('data-aus-counter') || c.textContent).match(NUM_RE);
      if (parts) {
        var decimals = (parts[2].replace(/,/g, '').split('.')[1] || '').length;
        c.textContent = parts[1] + (0).toFixed(decimals) + parts[3];
      }
    }

    observer.observe(root);
  }

  function scan(scope) {
    var roots = (scope || document).querySelectorAll('[data-aus-animate]');
    for (var i = 0; i < roots.length; i++) prep(roots[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { scan(document); });
  } else {
    scan(document);
  }

  // Re-scan sections re-rendered inside the theme editor.
  document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
})();
